export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat('nb-NO', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

export function formatSourceType(type: string): string {
  const labels: Record<string, string> = {
    m365: 'Microsoft 365',
    whatsapp: 'WhatsApp',
    gmail: 'Gmail',
    imap: 'IMAP',
    pst: 'PST',
    mbox: 'MBOX',
    eml: 'EML',
    sms_backup: 'SMS-backup',
    iphone_backup: 'iPhone-backup',
    document_upload: 'Dokumenter',
  };
  return labels[type] ?? type;
}
